export default function HeadStat({ label, value, sub, accent }) {
  return (
    <div className="text-center px-2 sm:px-3">
      <div className={`font-display text-xl leading-tight ${accent || "text-marine"}`}>{value}</div>
      <div className="text-xs uppercase tracking-wider text-marine/80 mt-0.5">{label}</div>
      {sub && <div className="text-xs text-marine/80">{sub}</div>}
    </div>
  );
}
